import * as angular from "angular"
import { IFertiliserProduct, IFertiliserStock, IOmniaShell, IParam, isNumber, param, StockType } from "../../omnia"
import { TypedStockEditCtrl } from "../editTypedStock"
import { FertiliserLiquidUnit } from "@omnia/shared/generated/enums"

const nutrientFields: string[] = ["N", "SO3", "P2O5", "K2O", "MgO", "Ca", "Na", "B"]

const nutrientWithNvFields: string[] = ["N", "SO3", "P2O5", "K2O", "MgO", "Ca", "Na", "B", "NeutralisingValue"]

const analysisFields: string[] = ["N", "SO3", "P2O5", "K2O", "MgO", "Ca", "Na", "B", "NeutralisingValue", "Liquid", "LiquidUnit", "SpecificGravity"]


export class FertiliserStockEditCtrl extends TypedStockEditCtrl {

    static create(): ng.IDirective {

        return TypedStockEditCtrl.create(FertiliserStockEditCtrl, "app/stocks/edit/fertiliser/editFertiliser.html");

    };

    static $inject = ["$scope", "OmniaShell"];

    private fertStock: IFertiliserStock = <any>{};

    public standardProducts: IFertiliserProduct[];

    public liquidUnits: IParam[];

    constructor($scope: ng.IScope, shell: IOmniaShell) {
        super($scope, shell)
    }

    protected setup() {

        const fertStock = this.fertStock = <IFertiliserStock>this.stock;

        this.liquidUnits = param.FertiliserLiquidUnit();

        this.standardProducts = this.stocks
            .getFertiliserProducts()
            .filter(p => (!p.Deleted) || (p.FertiliserProductId === fertStock?.StandardProductId))

    }

    protected getStockType() {
        return StockType.Fertiliser;
    }

    get customSelector(): any {
        return (this.fertStock.Custom ? "1" : "0");
    }

    set customSelector(value: any) {

        var custom = !!parseInt(value);

        if (custom != this.fertStock.Custom) {
            this.updateAnalysisFromStandardProduct();
            this.fertStock.Custom = !!parseInt(value);
        }
    }

    isCustom(): boolean {
        return this.fertStock && this.fertStock.Custom;
    }

    get liquidSelector(): any {
        var a = this.analysis;
        return (a && a.Liquid ? "1" : "0");
    }

    set liquidSelector(value: any) {
        this.fertStock.Liquid = !!parseInt(value);
    }

    get standardProduct(): IFertiliserProduct {
        return this.fertStock.StandardProduct;
    }

    set standardProduct(value: IFertiliserProduct) {

        var changed = (this.fertStock.StandardProduct != value);

        this.fertStock.StandardProduct = value;
        this.fertStock.StandardProductId = (value ? value.FertiliserProductId : null);

        if (changed) {
            this.updateAnalysisFromStandardProduct();
        }

    }

    get units(): string {
        if (this.analysis) {
            return this.analysis.Liquid ? "l" : "kg";
        }
    }

    get costUnits(): string {
        if (this.analysis) {
            return this.analysis.Liquid ? "m³" : "T";
        }
    }

    canChangeStock(): boolean {
        return (!this.isUsedInPlans());
    }

    canChangeAnalysis(): boolean {
        return (!this.isUsedInPlans()) && this.fertStock.Custom;
    }

    get analysis() {
        return this.fertStock.Custom ? this.fertStock : this.fertStock.StandardProduct;
    }

    requiresSpecificGravity(): boolean {
        var a = this.analysis;
        return (a && a.Liquid && (a.LiquidUnit == FertiliserLiquidUnit.WeightForWeight));
    }

    private updateAnalysisFromStandardProduct() {

        var p = this.fertStock.StandardProduct;

        if (p) {

            analysisFields.forEach(f => {
                this.fertStock[f] = p[f];
            });

        }

    }

    private hasAnyNutrientSet(): boolean {
        return nutrientWithNvFields.some(f => isNumber(this.analysis[f]));
    }


    checkTotalNutrientPct() {

        const so3 = this.analysis.SO3

        return so3
            ? true
            : (this.getTotalNutrientPct() <= 1)

    }

    getTotalNutrientPct(): number {
        return nutrientFields.map(f => this.analysis[f] || 0).reduce((v1, v2) => v1 + v2)
    }

    canShowNitrogenCost() {
        const { fertStock: s, analysis: a } = this
        return s && s.Cost && a && a.N
    }

    get nitrogenCost() {

        const { fertStock: s, analysis: a } = this

        if (s && a && a.N) {

            const f = a.Liquid && a.SpecificGravity
                ? a.SpecificGravity
                : 1

            return (s.Cost / (1000 * a.N)) / f

        }

    }

    getDefaultCo2e() {


        if (!this.isCustom()) {

            return this.standardProduct?.Co2e

        }
        else {

            const { fertStock: a } = this

            if (a) {
                const co2e = ((a.N || 0) * ((5.1 + 5.95) / 2)) + ((a.P2O5 || 0) * 0.54) + ((a.K2O || 0) * 0.42)
                return co2e
            }

        }

    }

    canCommit(): boolean {

        if (super.canCommit()) {

            if (this.fertStock.Custom) {
                if (!this.hasAnyNutrientSet()) return false
                if (!this.checkTotalNutrientPct()) return false
            }

            return true;

        }
    }

    commit(): ng.IPromise<any> {

        if (!this.canCommit()) {
            return;
        }

        let model = angular.merge({}, this.fertStock);

        if (!this.fertStock.Custom) {
            analysisFields.forEach(f => {
                delete model[f];
            });
        }

        model = this.prepareCommitModel(model);

        return this.stocks.editFertiliserStock(model);

    }

}
